const verify = {
    email: "",
    new_password: "",
    confirm_new_password: "",
};

const SET_VERIFY_INFO = 'SET_VERIFY_INFO'

export const setVerifyInfo = (verify) => ({
    type: SET_VERIFY_INFO,
    payload: verify,
});

const verify_store = (state = verify, action) => {
    switch (action.type) {
        case SET_VERIFY_INFO:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
};

export default verify_store;
